<!--移动端下载页面-->
<template>
  <div class="its-mobile-download" :class="[type]">
    <el-image class="its-mobile-img" :src="getSrc(type)"></el-image>
    <div class="its-detail-info">
      <div class="its-main-title">{{item.name}}</div>
      <div class="its-other-info">
        <span>版本：{{item.version}}</span>
        <span>大小：{{item.size}}</span>
      </div>
      <div class="its-btn" @click="downloadApp(item.url)">立即下载</div>
    </div>
  </div>
</template>
<script>
import { downloadCenterApi } from '../../../utils/api'
import { getOSVersion } from '../../../utils/screen'
export default {
  name: 'MobileDownload',
  data() {
    return {
      type: 'teacher', // 教师端、学生端
      item: {
        name: 'e课堂教师端',
        version: '1.1.4',
        size: '128M',
        url: '/q',
        identity: 'TEACHER_ANDROID'
      },
      appDownloads: []
    }
  },
  mounted() {
    //app信息，可能需要接口获取
    this.type = this.$route.params.type || 'teacher'
    if (this.type === 'student') {
      this.item = {
        name: 'e课堂学生端',
        version: '1.4.4',
        size: '65M',
        url: '/p',
        identity: 'STUDENT_ANDROID'
      }
    }
    this.getAppDownloads()
  },
  methods: {
    downloadApp: function (url) {
      let os = getOSVersion()
      if (os === 'mac') {
        alert('iOS版本正在开发中')
        return
      }
      window.location.href = url
    },
    getAppDownloads: function () {
      downloadCenterApi.getAllOnlineAppDownload().then((res) => {
        console.log(res)
        if (res.success) {
          this.appDownloads = res.body
          let download = this.getDownloadByIdentity(this.item.identity)
          this.item.url = download.url
          this.item.size = download.packageSize + 'M'
          this.item.version = download.version ? download.version : '1.0.0'
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getDownloadByIdentity: function (identity) {
      let app = {}
      this.appDownloads.forEach((item) => {
        if (item.identity === identity) {
          app = item
          return
        }
      })
      return app
    },
    getOSVersion: function () {
      let os = getOSVersion()
      return os
    },
    getSrc: function (type) {
      return require('@/assets/images/download_app_' + type + '.png')
    }
  }
}
</script>
<style scoped>
.its-mobile-download {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: white;
  z-index: 5000;
}
.its-mobile-img {
  position: absolute;
  margin: 0 10.54%;
  width: 78.92%;
  top: 16.72%;
}
.teacher .its-mobile-img {
  top: 15%;
}
.its-detail-info {
  position: absolute;
  margin: 0 23%;
  width: 54%;
  bottom: 9.75%;
  text-align: center;
}
.its-main-title {
  line-height: 1;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(17, 17, 17, 1);
  margin-bottom: 15px;
}
.its-other-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.its-other-info span {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
}
.its-btn {
  margin-top: 35px;
  width: 100%;
  height: 50px;
  line-height: 50px;
  border: 2px solid rgba(57, 87, 231, 1);
  border-radius: 45px;
  background: white;
  cursor: pointer;
  font-size: 15px;
  color: rgba(57, 87, 231, 1);
}
.its-btn:hover {
  color: rgba(57, 87, 231, 0.8);
  border: 2px solid rgba(57, 87, 231, 0.8);
}
</style>
